import React, { useState } from "react";

import TableChartIcon from "@material-ui/icons/TableChart";
import LockIcon from "@material-ui/icons/Lock";
import { Button, IconButton, makeStyles } from "@material-ui/core";
import { Link } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { selectedTableName } from "../../Store/atoms";

import "./styles.css";
import { formatDate } from "../../Utilities/DOMFunctions";

interface ITableProps {
  name: string;
  description: string;
  locked: boolean;
  lastEdited: string;
  customer: string;
  id: number;
  color: string;
}

const Table = ({
  name,
  description,
  customer,
  locked,
  lastEdited,
  id,
  color,
}: ITableProps) => {
  const setTableName = useSetRecoilState(selectedTableName);

  const handleClick = () => {
    setTableName(name);
  };

  return (
    <Link onClick={handleClick} className="table" to={"/tables/" + id}>
      <div className="table__customer-icon" style={{ backgroundColor: color }}>
        {customer}
      </div>
      <div className="table-info">
        <div className="table__name">{"Table " + name}</div>
        <div className="table__desc">{description}</div>
        <div className="table__last-edited">
          {"Last edited on: " + formatDate(lastEdited)}
        </div>
      </div>
      {locked && (
        <div className="table__locked">
          <LockIcon fontSize="large" />
        </div>
      )}
    </Link>
  );
};

export default Table;
